import React from 'react'

export interface SignInButtonProps {
  /** Where "Sign In" links to. Required — see AuthHeaderControlsProps.signInUrl. */
  signInUrl: string
}

/**
 * `SignInButton` — rendered by `AuthHeaderControls` in place of `UserMenuButton` +
 * `NotificationsButton` while the user is logged out (design doc §4.3). A plain link
 * styled to match the other 40x40 header icon-buttons (`BizFirstLinks`, `ThemeToggle`)
 * so the header never has an empty top-right corner on routes that are reachable while
 * logged out.
 */
export function SignInButton({ signInUrl }: SignInButtonProps): React.ReactElement {
  return (
    <a href={signInUrl} className="auth-sign-in-button" title="Sign In" aria-label="Sign In">
      <span>Sign In</span>
      <style>{`
        .auth-sign-in-button {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          padding: 0 16px;
          background: var(--color-primary, var(--obs-primary, #309B48));
          border: none;
          border-radius: 6px;
          color: white;
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
          cursor: pointer;
          transition: opacity 0.2s ease;
          white-space: nowrap;
        }

        .auth-sign-in-button:hover {
          opacity: 0.9;
        }
      `}</style>
    </a>
  )
}

export default SignInButton
